import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconLetterZCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLetterZCircle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M8.875 16.2275V15.4775L13.6621 8.81543V8.72168H9.03906V7.77246H15.0273V8.52246L10.2637 15.1846V15.2783H15.127V16.2275H8.875Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLetterZCircle;
